import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import { ComponentsModule } from './components/components.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {CoreModule} from './core/core.module';
import {BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {OrganizationModule} from './modules/organization/organization.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {ClipboardModule} from 'ngx-clipboard';


@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        CoreModule,
        BrowserAnimationsModule,
        NgxSkeletonLoaderModule,
        FormsModule,
        AppRoutingModule,
        AuthModule,
        ModalModule,
        DashboardModule,
        ComponentsModule,
        NgbModule,
        NgSelectModule,
        ClipboardModule,
        ToastrModule.forRoot()], providers: [BsModalService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
